import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
    
    constructor(private _jwtHelperService: JwtHelperService) {}
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let control = request.url;
        
        if(control.indexOf("table/v1/driving")){
            return next.handle(request);    
        }
        
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${this._jwtHelperService.tokenGetter()}`
            }
        });
        return next.handle(request);
    }
}
